/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prefer-destructuring */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { Fragment} from "react";
import MaterialTable from "material-table";
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import tableIcons from "./MaterialTableIcons";
import { Button } from '../../atomicComponents';
import styles from "./ApproveRejectBooking.module.css";
import { MESSAGE_TYPE} from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import {
  CustomFormGroup,
  CustomSelect,
} from "../FormComponents";


// import { DataGrid } from "@material-ui/data-grid";

function ApproveRejectBooking(){
  
    const { useState } = React;
    const [selected, setSelected] = useState(0);
    const [, setselectedData] = useState(null);
    const { showPopup } = usePopupManager();
    
    // const [selectionModel, setSelectionModel] = React.useState([]);
    // const { data } =useState({
    //   dataSet: "Commodity",
    //   rowLength: 10,
    //   maxColumns: 6
    // });
    const [bodyBuilderOption] = useState([
    {value:"test",label:"test"},
    {value:"test1",label:"test2"},
    {value:"test2",label:"test3"}

    ]);
    const [myState,setState] = React.useState(
      {
        // poNo: "",
        // stmNo: "",
        // chassisNo: null,
        // toDate: null,
        // fromDate: null,
        // bodyBuilder: null,
        checkFlag: false
  
      });

    
    const [columns] = useState([
      { title: 'Pers No', field: 'PersNo', editable:'false',colSpan:2 },
      { title: 'Employee Name', field: 'EmployeeName', editable:'false' },
      { title: 'Date', field: 'Date', type: "date", editable:'false'  },
      {
        title: 'Booking/Deletion', field: 'BookingDeletion', editable:'false'
        // lookup: { 34: 'İstanbul', 63: 'Şanlıurfa' },
      },
      {title:'Poject Code', field: 'PojectCode', editable:'false' ,
      
      render: () => <table className={styles.tableClass}> 
        <tr>
          <th className={clsx(styles.tdSize,styles.tdth)}>W.22EV.3111</th>
        </tr> 
        <tr>
          <th className={clsx(styles.tdSize,styles.tdth)}>W.22EV.3111</th>
        </tr> 
      </table>
    },
      {title:'Project Desc', field: 'ProjectDesc', editable:'false',
      render: () => <table className={styles.tableClass}> 
      <tr>
        <th className={clsx(styles.tdSize,styles.tdth)}>Test Project Timebooking</th>
      </tr> 
      <tr>
        <th className={clsx(styles.tdSize,styles.tdth)}>Administrative Work</th>
      </tr> 
    </table>
    
    
    },
      {title:'Gate', field: 'Gate', editable:'false',
    
      render: () => <table className={styles.tableClass}> 
      <tr>
        <th className={clsx(styles.tdSize,styles.tdth)}>FSR-Final Status Report</th>
      </tr> 
      <tr>
        <th className={clsx(styles.tdSize,styles.tdth)}>None</th>
      </tr> 
    </table>
    },

      {title:'Hrs', field: 'Hrs', editable:'false',
    
      render: () => <table className={styles.tableClass}> 
      <tr>
        <th className={clsx(styles.tdSize,styles.tdth)}>6.00</th>
      </tr> 
      <tr>
        <th className={clsx(styles.tdSize,styles.tdth)}>2.75</th>
      </tr> 
    </table>
    },
      {title:'EVM', field: 'EVM', editable:'false'},
      {title:'BRD', field: 'BRD',editable:'false'},
      {title:'Remark', field: 'Remark'},
      
    ]);
  
    const [data, setData] = useState([
      {PersNo: '1234', EmployeeName: 'Baran', Date: '18-5-2023', BookingDeletion: 'Booking', PojectCode:'B001234', ProjectDesc:'test project', Gate:'None', Hrs:'2H', EVM:"TEST",BRD:"TEST", Remark:'test'},
      {PersNo: '1234', EmployeeName: 'Jay', Date: '19-5-2023', BookingDeletion: 'Booking', PojectCode:'B001235', ProjectDesc:'test project2', Gate:'None', Hrs:'4H', EVM:"TEST",BRD:"TEST", Remark:'test project2'},
      {PersNo: '1234', EmployeeName: 'Baran', Date: '18-5-2023', BookingDeletion: 'Booking', PojectCode:'B001234', ProjectDesc:'test project', Gate:'None', Hrs:'2H',EVM:"TEST",BRD:"TEST", Remark:'test'},
      {PersNo: '1234', EmployeeName: 'Jay', Date: '19-5-2023', BookingDeletion: 'Booking', PojectCode:'B001235', ProjectDesc:'test project2', Gate:'None', Hrs:'4H',EVM:"TEST",BRD:"TEST", Remark:'test project2'},
      {PersNo: '1234', EmployeeName: 'Jay', Date: '19-5-2023', BookingDeletion: 'Booking', PojectCode:'B001235', ProjectDesc:'test project2', Gate:'None', Hrs:'4H',EVM:"TEST",BRD:"TEST", Remark:'test project2'},
    ]);
    // const [BCList, setBCList] = useState([
    //   {"id":1,
    //     "name":"0002323456"
    //   },
    //   {"id":2,
    //       "name":"0002323457"
    //   }
    //   ])
    // const [EmpList, setEmpList] = useState([
    //     {"id":1,
    //       "name":"323456-Amit"
    //     },
    //     {"id":2,
    //         "name":"323457-Sumit"
    //     }
    //     ])

        // const handleEditSelectedRows = () => {
        //   // Implement your logic to edit the selected rows
        //   console.log('Editing selected rows:', selectedRows);
        //   };

        const [, setBackgroundColors] = useState({
          processInfoBg: true,
          supplierInfoBg: false,
          poInfoBg: false,
          projectsInfoBg: false
        });
        // const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;
        // const handleOpen = () => setIsPopupOpen(true);
        // const handleClose = () => setIsPopupOpen(false);
        // const handleOpen1 = () => {
        //   setConfirmModal(true); };

        const changeBackgroundColor = (field) =>
          setBackgroundColors(prev => {
            const newBackgroundColors = {};
            // eslint-disable-next-line no-restricted-syntax
            for (const [key] of Object.entries(prev)) {
              if (key === field)
                newBackgroundColors[key] = true;
              else
                newBackgroundColors[key] = false;
            }
            return newBackgroundColors
          })

          const handleSubmit = async () => {
            if(selected===0){
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Kindly Select atleast one Record",
              });
            }
            else{
              showPopup({
                type: MESSAGE_TYPE.SUCCESS,
                contextText: MESSAGE_TYPE.SUCCESS,
                info: "Requests Approve Successfully",
              });
            }
          }

          const handleSubmit1 = async () => {
            if(selected===0){
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Kindly Select atleast one Record",
              });
            }
            else{
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Requests Rejected",
              });
            }
          }
          const handleSubmitbtn = async () => {
            setState(prevState => ({ ...prevState, tableFlag: true }))
    
        }
        const handleCancelclick = async () => {
          setState(prevState => ({ ...prevState, tableFlag: false }))
      }

          const renderReport = () => (
            <div
              className={styles.formGroup}        
            >  
              <div
              // className={styles.customeTable}
                // className={styles.col2} 
                style={{
                  width: "100%",
                  height: "50%",
                  marginTop:"10px",
                  marginBottom:"10px"
                }}
              > 
               <MaterialTable icons={tableIcons} 
                  options={{
                    paging: true,
                    actionsColumnIndex:-1,
                    selection: true,

                  }}
         
                    title=""
                    columns={columns}
                    data={data}

                    editable={{
                      
                      onBulkUpdate: changes =>
                        new Promise((resolve, reject) => {
                          setTimeout(() => {
                            resolve();
                          }, 1000);
                        }),     
                     
                    }}
                  
                    // editable={{
                    //   // isEditable: rowData => rowData.selection: true,               
                    //   onRowUpdate: (newData, oldData) =>
                       
                    //     new Promise((resolve) => {
                          
                    //       setTimeout(() => {
                    //         const dataUpdate = [...data];
                    //         const index = oldData.tableData.id;
                    //         dataUpdate[index] = newData;
                    //         setData([...dataUpdate]);

                    //         resolve();
                    //       }, 1000)
                    //     })
                    // }}                 
                    />
              </div> 
              <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
          
            <div className={styles.formDiv}>
                       <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                  onClick={() => handleSubmit()}
             //     disabled={(myState.chassisNo == null)}
                  data-testid="confirm-action"
                  style={{marginRight: "5px"}}
                >
                  Approve
                </Button>
             
                <Button
          className={clsx(styles.actionButton, styles.resetButton)}
          variant="tertiary"
          // onClick={handleOpen}
          onClick={() => handleSubmit1()}
          style={{marginRight: "5px"}}
          >
          Reject
        </Button>      
        <Button
                  className={clsx(
                    styles.actionButton,
                    styles.resetButton,
                  )}
                  variant="tertiary"
             //     disabled={(myState.chassisNo == null)}
                  data-testid="confirm-action"
                  style={{marginRight: "5px"}}
                  onClick={() =>handleCancelclick()}  
                >
                  Cancel
                </Button>
            </div>
          </div> 
        </Grid>
      </Grid>              
              </div>
          )
              
              

      const renderOther = () => (
        <div
          className={styles.formGroup}
          // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
          onClick={() => changeBackgroundColor('processInfoBg')}
        >
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{marginTop: "10px"}}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label> BC</label>
            </div>
            <div className={styles.formDiv}>

            <CustomSelect
              isDisabled={myState.checkFlag}
              // isMandatory
              // markIfUnselected={highlightMandatoryFields}
              // resetAllVisitedFields={resetAllVisitedFields}
              className={clsx(styles.select, styles.sel2)}
              isMulti
              isClearable
              options={bodyBuilderOption}
              value={myState.bodyBuilder}
              // onChange={(e) => { handleSelect(e, 'bodyBuilder') }}
              name="bodyBuilder"
            />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Employee</label>
            </div>
            <div className={styles.formDiv}>
            <CustomSelect
              isDisabled={myState.checkFlag}
              // isMandatory
              // markIfUnselected={highlightMandatoryFields}
              // resetAllVisitedFields={resetAllVisitedFields}
              className={clsx(styles.select, styles.sel2)}
              isMulti
              isClearable
              options={bodyBuilderOption}
              value={myState.bodyBuilder}
              // onChange={(e) => { handleSelect(e, 'bodyBuilder') }}
              name="bodyBuilder"
            />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>
        <Grid item md={3} lg={2}>
          <div className={styles.rowDiv}>
          
            <div className={styles.formDiv}>
       
            <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                  onClick={() => handleSubmitbtn()}
              //    disabled={(myState.chassisNo == null)}
                  data-testid="confirm-action"
                >
                  Submit
                </Button>
            </div>
          </div> 
        </Grid>
      </Grid>
    </div>
  )
  

    return (
    <>
    
      <div className={clsx(styles.scrollContainer, styles.scrollBar, styles.formContainer)}>
        <CustomFormGroup header='Search Report' body={renderOther()} />
        { myState.tableFlag &&
        <CustomFormGroup header='Report Details' body={renderReport()} />} 
      </div>
       {/* <div className={styles.container} > */}
      {/* style={{ background: "#F8F8F8", padding: 15, borderRadius: 9}}> */}
        
            {/* <div className={styles.formGroup}> */}
      {/* // <div className={clsx(styles.formGroupRow, styles.projectInfoFormGroupRow)}>
      
        // </div> */}
      </>
    )
  }
  
export default ApproveRejectBooking